/** Official Instagram profile — footer links & schema.org sameAs */
export const INSTAGRAM_URL = 'https://www.instagram.com/body_workstraining/';

/** Strip tracking params that trigger in-app Instagram preview overlays on mobile. */
export function normalizeInstagramUrl(url) {
  const raw = typeof url === 'string' ? url.trim() : '';
  if (!raw) return INSTAGRAM_URL;
  try {
    const u = new URL(raw);
    if (!u.hostname.includes('instagram.com')) return raw;
    u.search = '';
    u.hash = '';
    let path = u.pathname.replace(/\/+$/, '');
    if (!path || path === '/') path = '/body_workstraining';
    return `https://www.instagram.com${path}/`;
  } catch {
    return INSTAGRAM_URL;
  }
}

/** Prefer stored Admin URL unless it looks like the legacy handle. */
export function resolveInstagramUrl(stored) {
  const s = typeof stored === 'string' ? stored.trim() : '';
  if (!s) return INSTAGRAM_URL;
  if (s.toLowerCase().includes('carlotraining')) return INSTAGRAM_URL;
  return normalizeInstagramUrl(s);
}
